import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';
import * as CatalogActions from '../../../actions/CatalogActions';
import * as CalculatorActions from '../../../actions/CalculatorActions';
import {
    CalculatorApplicantSummaryDTO,
    DesiredVehicleApplicantSummaryDTO,
    FieldApplicantSummary,
} from '../../../types/mx/creditoReal/epics';
import {CalculatorStepViewFieldErrorState} from '../../../types/mx/creditoReal/reducers';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import * as ValidationActions from '../../../actions/ValidationActions';

const calculatorStepView = (state = defaultState.turboCash.ui.calculatorStepView, action) => {
    switch (action.type) {
        case CalculatorActions.CLEAN_QUOTAS_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    monthlyPaymentFieldError: null,
                    brandFieldError: action.brandSelectedId !== '' ? null : ValidateConstant.ERROR_REQUIRED,
                    modelFieldError: action.modelSelectedId !== '' ? null : ValidateConstant.ERROR_REQUIRED,
                    versionFieldError: action.versionSelectedId !== '' ? null : ValidateConstant.ERROR_REQUIRED
                }
            };
        case CatalogActions.GOT_BRANDS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    brandFieldError: !!action.brand && !!action.brand.id ? null : ValidateConstant.ERROR_REQUIRED
                }
            };
        case CatalogActions.GOT_MODELS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    modelFieldError: !!action.model && !!action.model.id ? null : ValidateConstant.ERROR_REQUIRED
                }
            };
        case CatalogActions.GOT_VERSIONS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    versionFieldError: !!action.version && !!action.version.id ? null : ValidateConstant.ERROR_REQUIRED
                }
            };
        case CatalogActions.GOT_PROVINCES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    provinceFieldError:
                        !!action.province && !!action.province.id ? null : ValidateConstant.ERROR_REQUIRED
                }
            };
        case CalculatorActions.YEAR_SELECTED_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    yearFieldError: action.error
                }
            };
        case CalculatorActions.BRAND_SELECTED_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    brandFieldError: action.error
                }
            };
        case CalculatorActions.MODEL_SELECTED_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    modelFieldError: action.error
                }
            };
        case CalculatorActions.VERSION_SELECTED_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    versionFieldError: action.error
                }
            };
        case CalculatorActions.PROVINCE_SELECTED_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    provinceFieldError: action.error
                }
            };
        case CalculatorActions.CHANGE_PRICE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    priceFieldError: action.error
                }
            };
        case CalculatorActions.CHANGE_DOWN_PAYMENT_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    downPaymentFieldError: action.error
                }
            };
        case ValidationActions.GOT_PRICE_AND_DOWN_PAYMENT_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    downPaymentFieldError: null,
                    yearFieldError: null
                }
            };
        case CalculatorActions.MONTHLY_PAYMENT_SELECTED_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    monthlyPaymentFieldError: action.error
                }
            };
        case WizardMXActions.SET_CALCULATOR_DATA_STATE_ACTION.name:
            const calculatorFS: FieldApplicantSummary<CalculatorApplicantSummaryDTO, CalculatorStepViewFieldErrorState>
                = action.fieldSummary;
            return {
                ...state,
                fieldErrors: calculatorFS.fieldErrors
            };
        case WizardMXActions.SET_DESIRED_VEHICLE_DATA_STATE_ACTION.name:
            const vehicleFS: FieldApplicantSummary<DesiredVehicleApplicantSummaryDTO, CalculatorStepViewFieldErrorState>
                = action.fieldSummary;
            return {
                ...state,
                fieldErrors: vehicleFS.fieldErrors
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name:
            return defaultState.turboCash.ui.calculatorStepView;
        default:
            return state;
    }

};

export default calculatorStepView;